export default __webpack_public_path__ + "static/media/attendance-profile.2b57a1b0.svg";